// extracted by mini-css-extract-plugin
export default {"home":"Home_home__b-E1J","screenshot1":"Home_screenshot1__WZG4A"};